<ng-container *ngIf="(membership.days_remaining !== null) && (membership.days_remaining > 0)">
  <p>Number of days frozen: {{ membership.days_remaining }}</p>
  <p>New bill date: {{ dateStringFromISO8601(membership.new_end_date_if_unfrozen) }}</p>
</ng-container>
<ng-container *ngIf="(membership.days_remaining === null) || (membership.days_remaining === 0)">
  <p>This membership has zero days frozen, so a new billing period will begin when it is unfrozen.</p>
  <p>The customer will be billed {{ organizationConfigService.getCurrencySymbol() }}{{ membership.billing_amount }}.</p>
</ng-container>

<div class="form-group">
  <label>Customize Customer Email Confirmation</label>
  <app-markdown-editor [(content)]="unfreezeEmailText" [id]="'unfreezeEmailText'"></app-markdown-editor>
</div>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
